import { render, staticRenderFns } from "./OdontogramAliases.vue?vue&type=template&id=2ded6174&scoped=true"
import script from "./OdontogramAliases.vue?vue&type=script&lang=js"
export * from "./OdontogramAliases.vue?vue&type=script&lang=js"
import style0 from "./OdontogramAliases.vue?vue&type=style&index=0&id=2ded6174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ded6174",
  null
  
)

export default component.exports